import { render, staticRenderFns } from "./certificateCheckModal.vue?vue&type=template&id=39a10fb5&scoped=true&"
import script from "./certificateCheckModal.vue?vue&type=script&lang=js&"
export * from "./certificateCheckModal.vue?vue&type=script&lang=js&"
import style0 from "./certificateCheckModal.vue?vue&type=style&index=0&id=39a10fb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a10fb5",
  null
  
)

export default component.exports